import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import DataGrid, { Column, Lookup, Editing } from 'devextreme-react/data-grid';
import { Item as TabItem } from "devextreme-react/tab-panel";
import Form, { GroupItem, SimpleItem, Label, FormRef } from "devextreme-react/form";
import IGroupeChasseur from "../../models/IGroupeChasseur";
import { FormListBase, FormListBaseTab, FormListBaseGrid, FormListBaseToolbar } from '../base';
import useCustomDataSource, { IFormBaseDataSourceOptions, Mode } from "../../hooks/useCustomDataSource";
import FormSysteme from '../../components/forms/form-systeme';
import useLookUpBase from '../../components/selectbox/LookupBase';
import GestionSecteurs from '../gestion-secteurs/gestion-secteurs';
import GestionTypesSejours from '../gestion-types-sejours/gestion-types-sejours';
import GestionLieuxSejour from '../gestion-lieux-sejour/gestion-lieux-sejour';
import useClient from '../../components/selectbox/client';
import Guid from '../../models/Guid';
import IClient from '../../models/IClient';
import IGroupeChasseurDetail from '../../models/IGroupeChasseurDetail';
import IGestionGroupeChasseur from '../../models/IGestionGroupeChasseur';
import GestionClient from '../gestion-client/gestionclient';
import { useContextPopupPage } from '../../components/popups/PopupPage';

interface IGestionGroupeChasseursProps {
  isModeSelection?: boolean,
  idGoupeChasseur?: Guid

}

export default function GestionGroupesChasseurs({ isModeSelection, idGoupeChasseur }: IGestionGroupeChasseursProps) {
  const groupeChasseurDataSourceOption: IFormBaseDataSourceOptions<IGestionGroupeChasseur> = useMemo(() => ({
    path: "groupeChasseur",
    customReadByIdPath: "groupeChasseur/{key}/gestion",
    customSauvegarderPath: "groupeChasseur/save",
    primaryKey: "idGroupeChasseur",
  }), []);
  // defaultId: idGoupeChasseur,
  // customReadByIdPath: "groupeChasseur/{key}/GetGroupeChasseur",
  // customSauvegarderPath: "groupeChasseur/sauvegarder",

  const groupeChasseurDataSource = useCustomDataSource<IGroupeChasseur, IGestionGroupeChasseur>(groupeChasseurDataSourceOption);
  const { selectedDataRow: selectedGroupeChasseur, setMainForm, setMode, mode, isFieldModifier, setIsFieldModifier, setSelectedDataRow, onFieldDataChanged } = groupeChasseurDataSource;
  const { setSelectedValue } = useContextPopupPage();
  const { editorOptions: secteurGroupeChasseurEditorOption, PopupGestion: PopupGestionSecteurGroupeChasseur } = useLookUpBase({
    isModeModifier: mode !== Mode.Lecture, controllerName: "secteur", showClear: mode !== Mode.Lecture,
    onClearRow: () => {
      setIsFieldModifier(true);
      formRef.current?.instance().updateData("idSecteur", Guid.empty.toString());
    },
    titre: "Gestionnaire des secteurs"
  })
  const { editorOptions: typeSejourGroupeChasseurEditorOption, PopupGestion: PopupGestionTypeSejourGroupeChasseur } = useLookUpBase({
    isModeModifier: mode !== Mode.Lecture, controllerName: "typesejours", showClear: mode !== Mode.Lecture,
    onClearRow: () => {
      setIsFieldModifier(true);
      formRef.current?.instance().updateData("idTypeSejour", Guid.empty.toString());
    },
    titre: "Gestionnaire des types de séjour"
  })
  const { editorOptions: lieuSejourGroupeChasseurEditorOption, PopupGestion: PopupGestionlieuSejourGroupeChasseur } = useLookUpBase({
    isModeModifier: mode !== Mode.Lecture, controllerName: "lieusejour", showClear: mode !== Mode.Lecture,
    onClearRow: () => {
      setIsFieldModifier(true);
      formRef.current?.instance().updateData("idLieuSejour", Guid.empty.toString());
    },
    titre: "Gestionnaire des lieux de séjour"
  })
  // const { editorOptions: clientEditorOption, PopupGestion: PopupGestionClient } = useLookUpBase({
  //   isModeModifier: mode !== Mode.Lecture, controllerName: "client", showClear: mode !== Mode.Lecture
  // })
  // const { ClientSelectBox, PopupGestionClient } = useClient();
  const { clientEditorOptions, PopupGestionClient } = useClient();
  const formRef = useRef<FormRef>(null);
  const dataGridFilterValue = useMemo(() => ["isDeleted", "anyof", [null, false]], []);

  const onSelectionchanged = (item: any, e: string) => {
    setIsFieldModifier(true);
    setSelectedDataRow((prev: IGestionGroupeChasseur) => {
      return { ...prev, [e]: item.id }
    })
  }

  const numeroOptions = useMemo(() => {
    return { maxLength: 15, width: 125 };
  }, []);
  const anneeOptions = useMemo(() => {
    return { width: 80, defaultValue: new Date().getFullYear(), min: 1970, max: new Date().getFullYear(), showSpinButtons: true };
  }, []);
  const noteOptions = useMemo(() => {
    return { height: 144, maxLength: 4000 };
  }, []);

  useEffect(() => {
    setMainForm(formRef.current?.instance());
  })

  useEffect(() => {
    if (mode !== Mode.Lecture) formRef.current?.instance().getEditor("description")?.focus();
  }, [mode])


  const onPopupGestionClientSelectionchanged = useCallback((selectedClient: IClient) => {
    if (mode === Mode.Lecture) return;
    console.log(selectedClient)

    // Get the currently focused row in the DataGrid
    const dataGrid = document.querySelector('.dx-datagrid') as any;
    const focusedRowIndex = dataGrid?.dxDataGrid?.option('focusedRowIndex');

    if (focusedRowIndex !== undefined && focusedRowIndex >= 0) {
      setSelectedDataRow((prevState) => {
        const updatedDetails = [...prevState.groupeChasseurDetails];
        if (updatedDetails[focusedRowIndex] && selectedClient.idClient) {
          updatedDetails[focusedRowIndex] = {
            ...updatedDetails[focusedRowIndex],
            idClient: selectedClient.idClient
          };
        }
        return {
          ...prevState,
          groupeChasseurDetails: updatedDetails
        };
      });
      setIsFieldModifier(true);
      // formRef.current?.instance().updateData("idSecteur", data.idSecteur);
    }
  }, [mode]);

  console.log(selectedGroupeChasseur)
  return (
    <FormListBase data={groupeChasseurDataSource}>
      <FormListBaseGrid dataSource={groupeChasseurDataSource.dataSource}
        onFocusedRowChanged={(e: any) => {
          if (mode === Mode.Modifier) setMode(Mode.Lecture);
          if (setSelectedValue && e?.row?.data) {
            setSelectedValue(e.row.data);
          }
        }}
      >
        <Column key={"grid-col-numero"} dataField={"numero"} caption="Numéro" allowHiding={false} />
        <Column key={"grid-col-annee"} dataField={"annee"} caption="Année" allowHiding={false} />
        <Column key={"grid-col-id-secteur"} dataField={"idSecteur"} caption="Secteur" allowHiding={false}>
          <Lookup {...secteurGroupeChasseurEditorOption} />
        </Column>
        <Column key={"grid-col-id-type-sejour"} dataField={"idTypeSejour"} caption="Type de séjour" allowHiding={false}>
          <Lookup {...typeSejourGroupeChasseurEditorOption} />
        </Column>
        <Column key={"grid-col-id-lieu-sejour"} dataField={"idLieuSejour"} caption="Lieu de séjour" allowHiding={false}>
          <Lookup {...lieuSejourGroupeChasseurEditorOption} />
        </Column>
      </FormListBaseGrid>
      <FormListBaseToolbar headerText={`Groupe #${selectedGroupeChasseur?.numero || ''}`} sauvegarderOptions={{ disabled: !isFieldModifier }} annulerOptions={{ disabled: !isFieldModifier }} />
      {!isModeSelection || isModeSelection && mode !== Mode.Lecture ? <FormListBaseTab>
        <PopupGestionSecteurGroupeChasseur
          onSelectionchanged={(data: any) => {
            setIsFieldModifier(true);
            formRef.current?.instance().updateData("idSecteur", data.idSecteur);
          }}
        >
          <GestionSecteurs isModeSelection={true} />
        </PopupGestionSecteurGroupeChasseur>
        <PopupGestionTypeSejourGroupeChasseur
          onSelectionchanged={(data: any) => {
            setIsFieldModifier(true);
            formRef.current?.instance().updateData("idTypeSejour", data.idTypeSejour);
          }}
        >
          <GestionTypesSejours isModeSelection={true} />
        </PopupGestionTypeSejourGroupeChasseur>
        <PopupGestionlieuSejourGroupeChasseur
          onSelectionchanged={(data: any) => {
            setIsFieldModifier(true);
            formRef.current?.instance().updateData("idLieuSejour", data.idLieuSejour);
          }}
        >
          <GestionLieuxSejour isModeSelection={true} />
        </PopupGestionlieuSejourGroupeChasseur>
        {/* <PopupGestionClient isModeSelection={mode !== Mode.Lecture} onSelectionchanged={onPopupGestionClientSelectionchanged} /> */}
        <PopupGestionClient isModeSelection={mode !== Mode.Lecture}
          onSelectionchanged={onPopupGestionClientSelectionchanged}
        />
        {/* <PopupGestionClient
          onSelectionchanged={(data: any) => {
            setIsFieldModifier(true);
            formRef.current?.instance().updateData("idLieuSejour", data.idLieuSejour);
          }}
        >
          <GestionClient isModeSelection={true} />
        </PopupGestionClient> */}
        <TabItem title="Informations">
          <div style={{ display: "flex" }}>
            <div style={{ width: "45%" }}>
              <Form ref={formRef} readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedGroupeChasseur || {} as IGroupeChasseur} className={"forms"} labelLocation={"left"} showColonAfterLabel={true} onFieldDataChanged={onFieldDataChanged}>
                <SimpleItem key={"frm-numero"} dataField={"numero"} editorOptions={numeroOptions}>
                  <Label text={"Numéro de groupe"} />
                </SimpleItem>
                <SimpleItem key={"frm-annee"} dataField={"annee"} editorType={"dxNumberBox"} editorOptions={anneeOptions}>
                  <Label text={"Année"} />
                </SimpleItem>
                <SimpleItem key={"frm-id-secteur"} dataField={"idSecteur"} editorType={"dxSelectBox"} editorOptions={secteurGroupeChasseurEditorOption}>
                  <Label text={"Secteur"} />
                </SimpleItem>
                <SimpleItem key={"frm-id-type-sejour"} dataField={"idTypeSejour"} editorType={"dxSelectBox"} editorOptions={typeSejourGroupeChasseurEditorOption}>
                  <Label text={"Type de séjour"} />
                </SimpleItem>
                <SimpleItem key={"frm-id-lieu-sejour"} dataField={"idLieuSejour"} editorType={"dxSelectBox"} editorOptions={lieuSejourGroupeChasseurEditorOption}>
                  <Label text={"Lieu de séjour"} />
                </SimpleItem>
              </Form>
            </div>
            <div style={{ width: "55%" }}>
              <Form readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedGroupeChasseur || {} as IGroupeChasseur} className={"forms"} labelLocation={"left"} showColonAfterLabel={true} onFieldDataChanged={onFieldDataChanged}>
                <SimpleItem key={"frm-note"} dataField={"note"}
                  editorType={"dxTextArea"} editorOptions={noteOptions}>
                  <Label text={"Notes"} location={"top"} showColon={false} />
                </SimpleItem>
              </Form>
            </div>
          </div>
          <Form readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedGroupeChasseur || {} as IGroupeChasseur} className={"forms"} labelLocation={"left"} showColonAfterLabel={true} onFieldDataChanged={onFieldDataChanged}>
            <GroupItem caption={"Chasseurs"}>
              <GroupItem>
                <DataGrid
                  keyExpr={"idClient"}
                  showBorders={true}
                  allowColumnResizing={true}
                  dataSource={selectedGroupeChasseur.groupeChasseurDetails}
                  filterValue={dataGridFilterValue}
                  height={"100%"}
                  noDataText={""}
                  onInitNewRow={(e: any) => {
                    e.data.idGroupeChasseur = selectedGroupeChasseur.idGroupeChasseur;
                    e.data.isDeleted = false;
                  }}
                  onRowInserting={(e: any) => {
                    if (!e.data.idClient) {
                      e.cancel = true;
                    }
                  }}
                  onRowUpdated={() => {
                    setIsFieldModifier(true);
                  }}
                  onEditorPreparing={(e: any) => {
                    // if (e.dataField === "idPermisType") {
                    const originalOnValueChanged = e.editorOptions.onValueChanged;
                    e.editorOptions.onValueChanged = (args: any) => {
                      if (originalOnValueChanged) {
                        originalOnValueChanged(args);
                      }

                      const currentData = e.component.option("dataSource");
                      const rowIndex = e.rowIndex;
                      const rowData = currentData[rowIndex];

                      if (!rowData.idGroupeChasseurDetail) {
                        const updatedData = currentData.filter((_: any, index: any) => index !== rowIndex);
                        setSelectedDataRow(prev => ({
                          ...prev,
                          groupeChasseurDetails: updatedData
                        }));
                        setIsFieldModifier(true);
                      }
                    };
                    // }
                  }}
                  onRowRemoving={async (e) => {
                    e.cancel = true;
                    // if (e?.data?.idPermisType) {
                    const index = selectedGroupeChasseur.groupeChasseurDetails.findIndex(item =>
                      item.idGroupeChasseurDetail?.equals(e.data.idGroupeChasseurDetail)
                    );
                    if (index !== -1) {
                      const updatedData = [...selectedGroupeChasseur.groupeChasseurDetails];
                      updatedData[index] = { ...updatedData[index], isDeleted: true };
                      setSelectedDataRow(prev => ({
                        ...prev,
                        groupeChasseurDetails: updatedData
                      }));
                      setIsFieldModifier(true);
                    }
                    // }
                  }}
                >
                  <Editing
                    mode="cell"
                    allowUpdating={mode !== Mode.Lecture}
                    allowDeleting={mode !== Mode.Lecture}
                    allowAdding={mode !== Mode.Lecture}
                    newRowPosition={"first"}
                    startEditAction={"click"}
                  />
                  {/* TODO client popup and noChasseur*/}
                  <Column caption={"Client"} dataField='idClient' dataType="string"
                    // cellRender={clientEditorOptions} editCellRender={clientEditorOptions} 
                    validationRules={[{ type: 'required', message: 'Le client est requis' }]}
                  >
                    <Lookup {...clientEditorOptions} />
                  </Column>
                  {/* <Column caption={"Client"} dataField='idClient' dataType="object" cellRender={clientEditorOptions} editCellRender={clientEditorOptions} /> */}
                  <Column caption={"No. chasseur"} dataField='numero' dataType='string' />
                  <Column caption={"Permis"} dataField='permisOrignal' dataType='string' />
                  <Column caption={"No. membre"} dataField='noMembre' dataType='string' />
                  <Column caption={"Forfait(s)"} dataField='forfaitOrignal' dataType='string' />
                  <Column caption={"Responsable"} dataField='responsable' dataType='boolean' />
                  <Column caption={"Responsable substitut"} dataField='responsableSubstitut' dataType='boolean' />
                  <Column dataField="isDeleted" dataType="boolean" visible={false} />
                </DataGrid>
              </GroupItem>
            </GroupItem>
            <SimpleItem>
              <Label text='0 chasseur' showColon={false}></Label>
            </SimpleItem>
          </Form>
        </TabItem>
        <TabItem title="Système"><FormSysteme formData={selectedGroupeChasseur || {} as IGroupeChasseur} /></TabItem>
      </FormListBaseTab> : null}
    </FormListBase>
  );
}
